import React, { useContext } from 'react';
import { bool, shape, func } from 'prop-types';
import { ExperienceContext, useStore } from '@thd-nucleus/experience-context';
import { CheckNearByStore } from './CheckNearbyStore';
import {
  isShowBuyInStoreNearBy,
  getSellableQuantityYourStore,
  productShape, getLocations, getPickupService,
} from '../../helpers/pod-fulfillment-utils';
import { BopisOffIcon } from '../../helpers/icon-utils';
import { isMobile, isFunction, getPickupStoreName } from '../../../components/helper/utils';
import { PICKUP_TEMPLATES } from '../../templates/templatesConstant';

export const BopisOffMessage = ({ product, isTwoTileEnabledFS, customRender }) => {
  const { channel } = useContext(ExperienceContext);
  const storeName = getPickupStoreName(product);

  const emptyComponent = () => {
    if (isFunction(customRender)) {
      return customRender({ pickUpTemplate: PICKUP_TEMPLATES.EMPTY_STORE_MESSAGE,
        isEmptyComponent: true,
        icon: null,
        value: {} });
    }
    return (<div className="store__message" />);
  };

  if (!(product && storeName)) {
    return emptyComponent();
  }

  const sellableQuantity = getSellableQuantityYourStore(product);
  const formattedQty = sellableQuantity > 999 ? '999+' : sellableQuantity;

  /** *  BopisOnOffMessage Subcomponents  ** */
  const storeNameLink = (isMobile(channel) || !isShowBuyInStoreNearBy(product))
    ? <span className="store__primary store__store-name store__text-adjustment">{storeName}</span>
    : <CheckNearByStore product={product} />;

  const secondLineMessage = sellableQuantity > 0
    ? (
      <>
        <span className="store__success">{`${formattedQty} in stock`}</span>
        <span className="store__primary">{' at '}</span>
        {storeNameLink}
      </>
    )
    : (
      <>
        <span className="store__primary">{'Visit '}</span>
        {storeNameLink}
        <span className="store__primary">{' to check availability'}</span>
      </>
    );

  const getTwoTileEnabledFsElements = () => {
    return (
      <div className="store__message">
        <div className="store__icon">{BopisOffIcon}</div>
        <div className="store__text-box">
          <div className="store__dark">At Your Store</div>
          <div id="check-nearby-store" className="store__second-line">
            <span className="store__success">{`${formattedQty} in stock`}</span>
            <span className="store__dark">, Not eligible for pickup</span>
          </div>
        </div>
      </div>
    );
  };

  if (isFunction(customRender)) {
    return customRender({ pickUpTemplate: PICKUP_TEMPLATES.BOPIS_OFF_MESSAGE,
      icon: BopisOffIcon,
      values: {
        storeNameLink, storeName, formattedQty, message: secondLineMessage, isTwoTileEnabledFS
      } });
  }

  return (
    isTwoTileEnabledFS ? getTwoTileEnabledFsElements() : (
      <div className="store__message">
        <div className="store__icon">{BopisOffIcon}</div>
        <div className="store__text-box">
          <div className="store__dark">Buy in Store</div>
          <div id="check-nearby-store" className="store__second-line">
            {secondLineMessage}
          </div>
        </div>
      </div>
    )
  );
};

BopisOffMessage.propTypes = {
  product: shape({ productShape }).isRequired,
  isTwoTileEnabledFS: bool,
  customRender: func
};

BopisOffMessage.defaultProps = {
  isTwoTileEnabledFS: false,
  customRender: null
};
